export default "__VITE_ASSET__DiZW1sBB__"